import { component } from 'picoapp';

export default component((node) => {
  if (node.scrollHeight > node.clientHeight) node.classList.add('clamped');
});
